import { Component, OnInit } from '@angular/core';
import { IGenericCrudConfiguration } from 'src/app/libs/components/generic-crud/generic-crud.component';
import {Format, FormatDimensions, ProcessSheets} from 'src/app/models';
import { MasterApiService } from 'src/app/services/master-api.service';
import { FormatsEditComponent } from './formats-edit/formats-edit.component';
import { FormatsAddComponent } from './formats-add/formats-add.component';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-formats',
    templateUrl: './formats.component.html',
    styleUrl: './formats.component.sass',
    standalone: false
})
export class FormatsComponent implements OnInit {

  configuration?: IGenericCrudConfiguration<Format>


  constructor(private api: MasterApiService, private translate: TranslateService) { }

  async ngOnInit(): Promise<void> {
    this.configuration = {
      resource: this.api.resources.product.formats,
      entityFields: {
        code: { isLink: true },
        name: { isLink: true },
        dimension: { calculateCellValue: (rowData: Format) => {
            return this.translate.instant('entity.format.' + FormatDimensions.find(d => d.id === rowData.dimension)?.name || '-') ;
          } },
      },
      editComponent: FormatsEditComponent,
      createComponent: FormatsAddComponent,
    };
  }
}
